
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    VisitTypeModal
} from './visittypesmodal';

export const visittypesathenastate = (
    context: any,
    initial?:VisitTypeModal[],
) => {
    const initValue = initial || [];

    return (
        state: VisitTypeModal[] = initValue,
        action: any, // Changed to any to catch all actions and debug
    ) => {
        const {
            type,
            payload,
        } = action || {};
        let updated = state;
        
        // Only log visit types related actions
        if (type && (type.includes('visittypes') || type === SET || type === REINIT)) {
            console.log('VisitTypes Reducer - Action received:', {
                type,
                payloadLength: Array.isArray(payload) ? payload.length : 'not array',
                payloadType: typeof payload,
                currentStateLength: state.length,
                action,
                SET_CONSTANT: SET,
                typeMatchesSET: type === SET
            });
        }
        
        switch (type) {
            case SET:
                console.log('VisitTypes Reducer - SET case, updating state:', {
                    oldLength: state.length,
                    newLength: Array.isArray(payload) ? payload.length : 0,
                    payload: payload,
                    payloadIsArray: Array.isArray(payload),
                    SET_CONSTANT: SET,
                    typeMatch: type === SET
                });
                updated = Array.isArray(payload) ? payload : [];
                break;

            case REINIT:
                console.log('VisitTypes Reducer - REINIT case');
                updated = initValue;
                break;
                
            default:
                console.log('VisitTypes Reducer - Default case (no match):', {
                    receivedType: type,
                    expectedSET: SET,
                    expectedREINIT: REINIT,
                    typesMatch: type === SET || type === REINIT
                });
                // Don't update state for unknown actions
                break;
        }
        
        console.log('VisitTypes Reducer - Returning state:', {
            updatedLength: updated.length,
            updated: updated
        });
        
        return updated;
    }
};
